import fileaxiosInstance from "api/fileAxiosInstance";
import SAlert from "components/Alert";
import { batch } from "react-redux";
import { provinceOutAction } from "./province-out-slice";
import axiosInstance from "api/axiosInstance";
import exportAxiosInstance from "api/exportAxiosInstance";
import FileSaver from "file-saver";

// Get Province Outs
export const getProvinceOuts =
  (
    url,
    pageNumber = 10,
    according = { order: "desc", name: "id" },
    search = null,
    advancedSearch = {}
  ) =>
  (dispatch) => {
    dispatch(provinceOutAction.setLoading(true));
    url = url || "/v1/province-outs";
    fileaxiosInstance
      .get(url, {
        params: {
          pageNumber: pageNumber,
          according: according,
          search: search,
          advancedSearch: advancedSearch,
        },
      })
      .then((response) => {
        if (response) {
          batch(() => {
            dispatch(provinceOutAction.setError(null));
            dispatch(provinceOutAction.setData(response.data));
            dispatch(provinceOutAction.setLoading(false));
          });
        }
      })
      .catch((error) => {
        dispatch(provinceOutAction.setLoading(false));
      });
  };

// Delete Many Province Out
export const deleteManyProvinceOut = (ids) => (dispatch) => {
  dispatch(provinceOutAction.setLoading(true));
  fileaxiosInstance
    .post("/v1/province-outs/delete/outs", { ids })
    .then((response) => {
      dispatch(getProvinceOuts());
      SAlert({ title: "Success", text: "Distributions successfully delete" });
      batch(() => {
        dispatch(provinceOutAction.setError(null));
        dispatch(provinceOutAction.setLoading(false));
      });
    })
    .catch((error) => {
      dispatch(provinceOutAction.setLoading(false));
      if (error?.response?.data?.deleteRistraction) {
        SAlert({
          text: error?.response?.data?.deleteRistraction,
          status: "warning",
          timer: 5000,
        });
      }
      console.log(error);
    });
};

// Delete Province Out
export const deleteProvinceOut = (id) => (dispatch) => {
  dispatch(provinceOutAction.setLoading(true));
  fileaxiosInstance
    .delete(`/v1/province-outs/${id}`)
    .then((response) => {
      dispatch(getProvinceOuts());
      SAlert({ title: "Success", text: "Receipt successfully delete" });
      batch(() => {
        dispatch(provinceOutAction.setError(null));
        dispatch(provinceOutAction.setLoading(false));
      });
    })
    .catch((error) => {
      dispatch(provinceOutAction.setLoading(false));
      if (error?.response?.data?.deleteRistraction) {
        SAlert({
          text: error?.response?.data?.deleteRistraction,
          status: "warning",
          timer: 5000,
        });
      }
      console.log(error);
    });
};

// Store Province Out
export const storeProvinceOut = (requests, navigate) => (dispatch) => {
  dispatch(provinceOutAction.setLoading(true));
  axiosInstance
    .post(`/v1/province-outs`, requests)
    .then((response) => {
      SAlert({ title: "Success", text: "Receipt successfully inserted" });
      navigate("/province-distributions");
      batch(() => {
        dispatch(provinceOutAction.setError(null));
        dispatch(provinceOutAction.setLoading(false));
      });
    })
    .catch((error) => {
      dispatch(provinceOutAction.setLoading(false));
      dispatch(provinceOutAction.setError(error?.response?.data?.errors));
      if (error?.response?.data?.error) {
        dispatch(
          provinceOutAction.setStoreQuantityError(error?.response?.data?.error)
        );
      }
    });
};

// Update Province Out
export const updateProvinceOut = (id, form, navigate) => (dispatch) => {
  dispatch(provinceOutAction.setLoading(true));
  axiosInstance
    .put(`/v1/province-outs/${id}`, form)
    .then((response) => {
      navigate("/province-distributions");
      SAlert({ title: "Success", text: "Distribution successfully updated" });
      batch(() => {
        dispatch(provinceOutAction.setError(null));
        dispatch(provinceOutAction.setLoading(false));
      });
    })
    .catch((error) => {
      dispatch(provinceOutAction.setLoading(false));
      dispatch(provinceOutAction.setError(error?.response?.data?.errors));
      console.log(error);
    });
};

// Get Province Out By ID
export const getByIdProvinceOut = (id) => (dispatch) => {
  dispatch(provinceOutAction.setLoading(true));
  fileaxiosInstance
    .get(`/v1/province-outs/${id}`)
    .then((response) => {
      batch(() => {
        dispatch(provinceOutAction.setError(null));
        dispatch(provinceOutAction.setProvinceOut(response?.data));
        dispatch(provinceOutAction.setLoading(false));
      });
    })
    .catch((error) => {
      dispatch(provinceOutAction.setLoading(false));
      console.log(error);
    });
};

// Get Province Out Receipts
export const getProvinceOutReceipts =
  (params = {}) =>
  (dispatch) => {
    dispatch(
      provinceOutAction.setProvinceOutReceipts({
        loading: true,
        error: null,
        data: null,
      })
    );
    fileaxiosInstance
      .get(`/v1/get-province-out-receipts`, { params: params })
      .then((respnose) => {
        dispatch(
          provinceOutAction.setProvinceOutReceipts({
            loading: false,
            error: null,
            data: respnose?.data,
          })
        );
      })
      .catch((error) => {
        dispatch(
          provinceOutAction.setProvinceOutReceipts({
            loading: false,
            error: error?.response,
            data: null,
          })
        );
        console.log(error);
      });
  };

// Get Province Out Provinces
export const getProvinceOutProvinces = () => (dispatch) => {
  dispatch(
    provinceOutAction.setProvinces({
      loading: true,
      error: null,
      data: [],
    })
  );
  axiosInstance
    .get(`/v1/get-province-out-provinces`)
    .then((respnose) => {
      dispatch(
        provinceOutAction.setProvinces({
          loading: false,
          error: null,
          data: respnose?.data,
        })
      );
    })
    .catch((error) => {
      dispatch(
        provinceOutAction.setProvinces({
          loading: false,
          error: error?.response,
          data: null,
        })
      );
      console.log(error);
    });
};

// Get Province Out Items
export const getProvinceOutItems = (category_id) => (dispatch) => {
  dispatch(
    provinceOutAction.setItems({
      loading: true,
      error: null,
      data: [],
    })
  );
  axiosInstance
    .get(`/v1/get-province-out-items/${category_id}`)
    .then((respnose) => {
      dispatch(
        provinceOutAction.setItems({
          loading: false,
          error: null,
          data: respnose?.data,
        })
      );
    })
    .catch((error) => {
      dispatch(
        provinceOutAction.setItems({
          loading: false,
          error: error?.response,
          data: null,
        })
      );
      console.log(error);
    });
};

// Export Province Out
export const exportProvinceOut =
  (advancedSearch = {}) =>
  (dispatch) => {
    dispatch(
      provinceOutAction.setExportStatus({
        loading: true,
        error: null,
      })
    );

    exportAxiosInstance
      .get("/v1/export-province-outs", {
        params: advancedSearch,
      })
      .then((response) => {
        if (response) {
          const dataBlob = new Blob([response?.data], {
            type: "application/pdf,",
          });
          FileSaver.saveAs(
            dataBlob,
            `Province-Out-${Math.random().toString()}.xlsx`
          );
          dispatch(
            provinceOutAction.setExportStatus({
              loading: false,
              error: null,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          provinceOutAction.setExportStatus({
            loading: false,
            error: error?.response?.errors,
          })
        );
        console.log(error);
      });
  };

// Get Province Out Drafts
export const getProvinceOutDrafts = () => (dispatch) => {
  dispatch(
    provinceOutAction.setDrafts({
      loading: true,
      error: null,
      data: [],
    })
  );

  fileaxiosInstance
    .get("/v1/province-outs-draft", {
      params: {
        pageNumber: 1000, // Get all drafts
      },
    })
    .then((response) => {
      dispatch(
        provinceOutAction.setDrafts({
          loading: false,
          error: null,
          data: response?.data?.data?.data || [],
        })
      );
    })
    .catch((error) => {
      dispatch(
        provinceOutAction.setDrafts({
          loading: false,
          error: error?.response,
          data: [],
        })
      );
      console.log(error);
    });
};

// Store Province Out Draft
export const storeProvinceOutDraft = (draftData) => (dispatch) => {
  dispatch(provinceOutAction.setDraftLoading(true));

  const formData = new FormData();

  // Append all draft data
  formData.append("data", JSON.stringify(draftData));

  // Append the file if it exists
  if (draftData.document) {
    formData.append("document", draftData.document);
  }

  fileaxiosInstance
    .post("/v1/province-outs-draft", formData)

    .then((response) => {
      dispatch(provinceOutAction.addDraft(response.data.data));
      dispatch(provinceOutAction.setDraftLoading(false));
      // Reload all drafts to get the latest data
      dispatch(getProvinceOutDrafts());
      SAlert({
        title: "Success",
        text: "Draft saved successfully",
        status: "success",
      });
    })
    .catch((error) => {
      dispatch(provinceOutAction.setDraftLoading(false));
      SAlert({
        text: error?.response?.data?.message || "Failed to save draft",
        status: "error",
      });
      console.log(error);
    });
};

// Update Province Out Draft (Simple Modal Edit)
export const updateProvinceOutDraftSimple = (id, data) => (dispatch) => {
  dispatch(provinceOutAction.setDraftLoading(true));

  return fileaxiosInstance
    .put(`/v1/province-outs-draft/${id}`, data)
    .then((response) => {
      dispatch(provinceOutAction.updateDraft(response.data.data));
      dispatch(provinceOutAction.setDraftLoading(false));
      // Reload all drafts to get the latest data
      dispatch(getProvinceOutDrafts());
      SAlert({
        title: "Success",
        text: "Draft updated successfully",
        status: "success",
      });
      return response;
    })
    .catch((error) => {
      dispatch(provinceOutAction.setDraftLoading(false));
      SAlert({
        text: error?.response?.data?.message || "Failed to update draft",
        status: "error",
      });
      console.log(error);
      throw error;
    });
};

// Update Province Out Draft (Full Form Data)
export const updateProvinceOutDraft = (id, formData) => (dispatch) => {
  dispatch(provinceOutAction.setDraftLoading(true));

  return fileaxiosInstance
    .post(`/v1/province-outs-draft/${id}`, formData)
    .then((response) => {
      dispatch(provinceOutAction.updateDraft(response.data.data));
      dispatch(provinceOutAction.setDraftLoading(false));
      // Reload all drafts to get the latest data
      dispatch(getProvinceOutDrafts());
      SAlert({
        title: "Success",
        text: "Draft updated successfully",
        status: "success",
      });
      return response;
    })
    .catch((error) => {
      dispatch(provinceOutAction.setDraftLoading(false));
      SAlert({
        text: error?.response?.data?.message || "Failed to update draft",
        status: "error",
      });
      console.log(error);
      throw error;
    });
};

// Delete Province Out Draft
export const deleteProvinceOutDraft = (id) => (dispatch) => {
  dispatch(provinceOutAction.setDraftLoading(true));

  fileaxiosInstance
    .delete(`/v1/province-outs-draft/${id}`)
    .then((response) => {
      dispatch(provinceOutAction.removeDraft(id));
      dispatch(provinceOutAction.setDraftLoading(false));
      // Reload all drafts to get the latest data
      dispatch(getProvinceOutDrafts());
      SAlert({
        title: "Success",
        text: "Draft deleted successfully",
        status: "success",
      });
    })
    .catch((error) => {
      dispatch(provinceOutAction.setDraftLoading(false));
      SAlert({
        text: error?.response?.data?.message || "Failed to delete draft",
        status: "error",
      });
      console.log(error);
    });
};

// Delete Multiple Province Out Drafts
export const deleteManyProvinceOutDrafts = (ids) => (dispatch) => {
  dispatch(provinceOutAction.setDraftLoading(true));

  fileaxiosInstance
    .post("/v1/province-outs-draft/delete-many", { ids })
    .then((response) => {
      ids.forEach((id) => dispatch(provinceOutAction.removeDraft(id)));
      dispatch(provinceOutAction.setDraftLoading(false));
      // Reload all drafts to get the latest data
      dispatch(getProvinceOutDrafts());
      SAlert({
        title: "Success",
        text: "Drafts deleted successfully",
        status: "success",
      });
    })
    .catch((error) => {
      dispatch(provinceOutAction.setDraftLoading(false));
      SAlert({
        text: error?.response?.data?.message || "Failed to delete drafts",
        status: "error",
      });
      console.log(error);
    });
};

// Get Province Out Draft By ID
export const getByIdProvinceOutDraft = (id) => (dispatch) => {
  dispatch(provinceOutAction.setLoading(true));

  fileaxiosInstance
    .get(`/v1/province-outs-draft/${id}`)
    .then((response) => {
      dispatch(provinceOutAction.setError(null));
      dispatch(provinceOutAction.setProvinceOut(response?.data));
      dispatch(provinceOutAction.setLoading(false));
    })
    .catch((error) => {
      dispatch(provinceOutAction.setLoading(false));
      dispatch(
        provinceOutAction.setError(
          error?.response?.data?.message || "Failed to fetch draft"
        )
      );
      console.log(error);
    });
};

export const updateProvinceOutDraftsToSubmitted = (navigate) => (dispatch) => {
  dispatch(provinceOutAction.setLoading(true));
  dispatch(provinceOutAction.setStoreQuantityError([]));
  
  fileaxiosInstance
    .patch(`/v1/province-outs-update-drafts-status`, { status: "submitted" })
    .then((response) => {
      // Clear drafts from state after successful submission
      dispatch(provinceOutAction.resetDrafts());
      dispatch(provinceOutAction.setStoreQuantityError([]));
      navigate("/province-distributions");
      SAlert({ 
        title: "Success", 
        text: "All distributions successfully created",
        status: "success"
      });
      dispatch(provinceOutAction.setLoading(false));
    })
    .catch((error) => {
      dispatch(provinceOutAction.setLoading(false));
      
      // Handle error messages
      if (error?.response?.data?.error) {
        dispatch(provinceOutAction.setStoreQuantityError(error.response.data.error));
      } else if (error?.response?.data?.message) {
        SAlert({ 
          title: "Error", 
          text: error.response.data.message,
          status: "error"
        });
      } else {
        SAlert({ 
          title: "Error", 
          text: "Failed to submit drafts. Please try again.",
          status: "error"
        });
      }
    });
};
